import React, { useState } from "react";
import clsx from "clsx";

import ListItem from "@material-ui/core/ListItem";
import Button from "@material-ui/core/Button";
import AddIcon from "@material-ui/icons/LocalHospitalOutlined";

import type { racehorse360 } from "@tsg/1st-grpc-web-rh360";

import { getTrainerFieldContentOrNumber } from "utils/trainer";
import { getPersonFullName } from "utils/person";
import { DASH } from "common/constants";
import ChangeTrainerPopup from "components/ChangeTrainerPopup";
import { useLoggedInUser } from "components/LoggedInUserProvider";

import useStyles from "./styles";

interface IProps {
  horse: racehorse360.IHorse;
  onChangeHorse: (horse: racehorse360.IHorse) => void;
}

const TrainerListItem = (props: IProps) => {
  const { horse, onChangeHorse } = props;

  const classes = useStyles();

  const { isVeterinarian, isRegulatoryVet, isAdmin, isRacingOfficial } =
    useLoggedInUser().currentUser;
  const isTrainerEditable = [
    isVeterinarian && !isRegulatoryVet,
    isRacingOfficial,
    isAdmin
  ].some(Boolean);

  const [isPopupOpen, setIsPopupOpen] = useState(false);

  const trainerInfo = getTrainerFieldContentOrNumber(
    getPersonFullName(horse.trainer, "%F %L"),
    horse.trainer
  );

  const handleOpenPopup = () => {
    setIsPopupOpen(true);
  };

  const handleClosePopup = () => {
    setIsPopupOpen(false);
  };

  const handleChangeTrainer = (horsePatch: racehorse360.IHorse) => {
    onChangeHorse({ ...horse, ...horsePatch });
    setIsPopupOpen(false);
  };

  const renderItemContent = () => {
    if (!isTrainerEditable) {
      return <div>{trainerInfo || DASH}</div>;
    }

    return (
      <Button
        className={clsx(classes.trainerInfoButton, {
          [classes.iconButton]: Boolean(!trainerInfo)
        })}
        onClick={handleOpenPopup}
      >
        {trainerInfo || <AddIcon />}
      </Button>
    );
  };

  return (
    <>
      <ListItem className={classes.listItem}>
        <div className={classes.listItemLabel}>Trainer</div>
        <div className={classes.listItemValue}>{renderItemContent()}</div>
      </ListItem>

      {isPopupOpen && (
        <ChangeTrainerPopup
          open={isPopupOpen}
          onClose={handleClosePopup}
          selectedHorse={horse}
          onChangeTrainer={handleChangeTrainer}
        />
      )}
    </>
  );
};

export default React.memo(TrainerListItem);
